"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMomentCode = exports.isMomentSupported = exports.SUPPORTED_CONTAINERS_LANGUAGES = exports.MONOLITH_LANGUAGE_MAPPINGS = exports.DYNAMIC_TRANSLATIONS_LANGUAGE_MAPPINGS = exports.LANG_LOCALE_MAPPING = exports.DEFAULT_LANGUAGE_CODE = void 0;
var lodash_1 = __importDefault(require("lodash"));
exports.DEFAULT_LANGUAGE_CODE = 'EN';
/**
 * XM Languages supported by printed-reports.
 * The languages with asteriks are additional dashboard-viewer languages.
 * Keys should match the language codes from:
 * https://gitlab-app.eng.qops.net/monolith/language/-/tree/master/Messages
 * locale should match locales from:
 * https://gitlab-app.eng.qops.net/dashboards/dashboards-static-translate/-/tree/master/src/lang
 */
exports.LANG_LOCALE_MAPPING = {
    // English
    'EN': {
        locale: 'en-US',
        angularLocale: 'en-us',
        htmlLocale: 'en',
        momentLocale: 'en',
        RFC3066LanguageTag: 'en'
    },
    // French
    'FR': {
        locale: 'fr-FR',
        angularLocale: 'fr-fr',
        htmlLocale: 'fr',
        momentLocale: 'fr',
        RFC3066LanguageTag: 'fr'
    },
    // Spanish
    'ES-ES': {
        locale: 'es-ES',
        angularLocale: 'es-es',
        htmlLocale: 'es',
        momentLocale: 'es',
        RFC3066LanguageTag: 'es-ES'
    },
    // Spanish, Latin America
    'ES': {
        locale: 'es-419',
        angularLocale: 'es-419',
        htmlLocale: 'es',
        momentLocale: 'es',
        RFC3066LanguageTag: 'es'
    },
    // Portuguese
    'PT': {
        locale: 'pt-PT',
        angularLocale: 'pt-pt',
        htmlLocale: 'pt',
        momentLocale: 'pt',
        RFC3066LanguageTag: 'pt-PT'
    },
    // Portuguese, Brazilian
    'PT-BR': {
        locale: 'pt-BR',
        angularLocale: 'pt-br',
        htmlLocale: 'pt',
        momentLocale: 'pt-br',
        RFC3066LanguageTag: 'pt-BR'
    },
    // Italian
    'IT': {
        locale: 'it-IT',
        angularLocale: 'it-it',
        htmlLocale: 'it',
        momentLocale: 'it',
        RFC3066LanguageTag: 'it'
    },
    // German
    'DE': {
        locale: 'de-DE',
        angularLocale: 'de-de',
        htmlLocale: 'de',
        momentLocale: 'de',
        RFC3066LanguageTag: 'de'
    },
    // Dutch
    'NL': {
        locale: 'nl-NL',
        angularLocale: 'nl-nl',
        htmlLocale: 'nl',
        momentLocale: 'nl',
        RFC3066LanguageTag: 'nl'
    },
    // Japanese
    'JA': {
        locale: 'ja-JP',
        angularLocale: 'ja-jp',
        htmlLocale: 'ja',
        momentLocale: 'ja',
        RFC3066LanguageTag: 'ja'
    },
    // Korean
    'KO': {
        locale: 'ko-KR',
        angularLocale: 'ko-kr',
        htmlLocale: 'ko',
        momentLocale: 'ko',
        RFC3066LanguageTag: 'ko'
    },
    // Finnish
    'FI': {
        locale: 'fi-FI',
        angularLocale: 'fi-fi',
        htmlLocale: 'fi',
        momentLocale: 'fi',
        RFC3066LanguageTag: 'fi'
    },
    // Chinese, simplified*
    'ZH-S': {
        locale: 'zh-S',
        angularLocale: 'zh-hans',
        htmlLocale: 'zh-Hans',
        momentLocale: 'zh-cn',
        RFC3066LanguageTag: 'zh-Hans'
    },
    // Chinese, traditional*
    'ZH-T': {
        locale: 'zh-T',
        angularLocale: 'zh-hant',
        htmlLocale: 'zh-Hant',
        momentLocale: 'zh-hk',
        RFC3066LanguageTag: 'zh-Hant'
    },
    // Polish*
    'PL': {
        locale: 'pl-PL',
        angularLocale: 'pl-pl',
        htmlLocale: 'pl',
        momentLocale: 'pl',
        RFC3066LanguageTag: 'pl'
    },
    // Turkish*
    'TR': {
        locale: 'tr-TR',
        angularLocale: 'tr-tr',
        htmlLocale: 'tr',
        momentLocale: 'tr',
        RFC3066LanguageTag: 'tr'
    },
    // Czech*
    'CS': {
        locale: 'cs-CZ',
        angularLocale: 'cs-cz',
        htmlLocale: 'cs',
        momentLocale: 'cs',
        RFC3066LanguageTag: 'cs'
    },
    // Hungarian*
    'HU': {
        locale: 'hu-HU',
        angularLocale: 'hu-hu',
        htmlLocale: 'hu',
        momentLocale: 'hu',
        RFC3066LanguageTag: 'hu'
    },
    // Greek*
    'EL': {
        locale: 'el-GR',
        angularLocale: 'el-gr',
        htmlLocale: 'el',
        momentLocale: 'el',
        RFC3066LanguageTag: 'el'
    },
    // Slovak*
    'SK': {
        locale: 'SK-SK',
        angularLocale: 'sk-sk',
        htmlLocale: 'sk',
        momentLocale: 'sk',
        RFC3066LanguageTag: 'sk'
    },
    // Romanian*
    'RO': {
        locale: 'ro-RO',
        angularLocale: 'ro-ro',
        htmlLocale: 'ro',
        momentLocale: 'ro',
        RFC3066LanguageTag: 'ro'
    },
    // Slovenian*
    'SL': {
        locale: 'sl-SL',
        angularLocale: 'sl-si',
        htmlLocale: 'sl',
        momentLocale: 'sl',
        RFC3066LanguageTag: 'sl'
    },
    // Bulgarian*
    'BG': {
        locale: 'bg-BG',
        angularLocale: 'bg-bg',
        htmlLocale: 'bg',
        momentLocale: 'bg',
        RFC3066LanguageTag: 'bg'
    },
    // Croatian*
    'HR': {
        locale: 'hr-HR',
        angularLocale: 'hr-hr',
        htmlLocale: 'hr',
        momentLocale: 'hr',
        RFC3066LanguageTag: 'hr'
    },
    // Thai*
    'TH': {
        locale: 'th-TH',
        angularLocale: 'th-th',
        htmlLocale: 'th',
        momentLocale: 'th',
        RFC3066LanguageTag: 'th'
    },
    // Russian*
    'RU': {
        locale: 'ru-RU',
        angularLocale: 'ru-ru',
        htmlLocale: 'ru',
        momentLocale: 'ru',
        RFC3066LanguageTag: 'ru-RU'
    },
    // English UK
    'EN-GB': {
        locale: 'en-GB',
        angularLocale: 'en-gb',
        htmlLocale: 'en',
        momentLocale: 'en-gb',
        RFC3066LanguageTag: 'en-GB'
    },
    // Arabic
    'AR': {
        locale: '',
        angularLocale: 'ar',
        htmlLocale: 'ar',
        momentLocale: 'ar',
        RFC3066LanguageTag: 'ar'
    },
    // Bosnian
    'BS': {
        locale: '',
        angularLocale: 'bs',
        htmlLocale: 'bs',
        momentLocale: 'bs',
        RFC3066LanguageTag: 'bs'
    },
    // French (Canada)
    'FR-CA': {
        locale: '',
        angularLocale: 'fr-ca',
        htmlLocale: 'fr',
        momentLocale: 'fr-ca',
        RFC3066LanguageTag: 'fr-CA'
    },
    // Hebrew
    'HE': {
        locale: '',
        angularLocale: 'he',
        htmlLocale: 'he',
        momentLocale: 'he',
        RFC3066LanguageTag: 'he'
    },
    // Lithuanian
    'LT': {
        locale: '',
        angularLocale: 'lt',
        htmlLocale: 'lt',
        momentLocale: 'lt',
        RFC3066LanguageTag: 'lt'
    },
    // Serbian
    'SR': {
        locale: '',
        angularLocale: 'sr',
        htmlLocale: 'sr',
        momentLocale: 'sr',
        RFC3066LanguageTag: 'sr'
    },
    // Vietnamese
    'VI': {
        locale: '',
        angularLocale: 'vi',
        htmlLocale: 'vi',
        momentLocale: 'vi',
        RFC3066LanguageTag: 'vi'
    },
    // Bahasa Indonesia
    'ID': {
        locale: 'id-ID',
        angularLocale: 'id-id',
        htmlLocale: 'id, in',
        momentLocale: 'id',
        RFC3066LanguageTag: 'id'
    },
    // Ukrainian
    'UK': {
        locale: 'uk-UK',
        angularLocale: 'uk',
        htmlLocale: 'uk',
        momentLocale: 'uk',
        RFC3066LanguageTag: 'uk'
    },
    // Danish*
    'DA': {
        locale: 'da-DK',
        angularLocale: 'da',
        htmlLocale: 'da',
        momentLocale: 'da',
        RFC3066LanguageTag: 'da'
    },
    // Swedish*
    'SV': {
        locale: 'sv-SE',
        angularLocale: 'sv',
        htmlLocale: 'sv',
        momentLocale: 'sv',
        RFC3066LanguageTag: 'sv'
    },
    // Developer (test language)
    'DEV': {
        locale: 'en-US',
        angularLocale: 'en-us',
        htmlLocale: 'en',
        isTest: true,
        RFC3066LanguageTag: 'en-US'
    },
    // Psuedoloc (test language)
    'PB': {
        locale: 'PB',
        angularLocale: 'en-us',
        htmlLocale: 'en',
        isTest: true,
        RFC3066LanguageTag: 'en-US'
    },
    // Rigi
    'RI-GI': {
        locale: 'ri-GI',
        angularLocale: 'en-us',
        htmlLocale: 'en',
        isTest: true,
        RFC3066LanguageTag: 'en-US'
    },
    // Bahasa Malaysia (Malay)
    'MS': {
        locale: 'ms-MY',
        angularLocale: 'ms',
        htmlLocale: 'ms',
        momentLocale: 'ms',
        RFC3066LanguageTag: 'ms'
    },
    // Norwegian
    'NO': {
        locale: 'no-NO',
        angularLocale: 'no-no',
        htmlLocale: 'no',
        RFC3066LanguageTag: 'no'
    },
    // Welsch
    'CY': {
        locale: 'cy-CY',
        angularLocale: 'cy-GB',
        htmlLocale: 'cy',
        RFC3066LanguageTag: 'cy'
    },
    // Hindi
    'HI': {
        locale: 'hi-IN',
        angularLocale: 'hi-IN',
        htmlLocale: 'hi',
        RFC3066LanguageTag: 'hi'
    },
    // Armenian
    'HYE': {
        locale: 'hy',
        angularLocale: 'hy-AM',
        htmlLocale: 'hy',
        RFC3066LanguageTag: 'hy'
    },
    // Macedonian
    'MK': {
        locale: 'mk',
        angularLocale: 'mk-MK',
        htmlLocale: 'mk',
        RFC3066LanguageTag: 'mk'
    },
    // Latvian
    'LV': {
        locale: 'lv',
        angularLocale: 'lv-LV',
        htmlLocale: 'lv',
        RFC3066LanguageTag: 'lv'
    },
    // Estonian
    'ET': {
        locale: 'et-EE',
        angularLocale: 'et-EE',
        htmlLocale: 'et',
        RFC3066LanguageTag: 'et'
    }
};
/**
 * For Russian, language code in user account setting is RU.
 * Containers API expects it as RU-RU. This maps language codes in Monolith to the ones containers API expects.
 * See https://gitlab-app.eng.qops.net/reporting-framework/containers-api/blob/master/src/models/Translations.ts
 */
exports.DYNAMIC_TRANSLATIONS_LANGUAGE_MAPPINGS = {
    RU: 'RU-RU',
    HYE: 'HY'
};
// Maps language codes from containers API to the ones Printed Reports expects.
exports.MONOLITH_LANGUAGE_MAPPINGS = {
    'RU-RU': 'RU',
    'HY': 'HYE'
};
exports.SUPPORTED_CONTAINERS_LANGUAGES = lodash_1.default.filter(lodash_1.default.keys(exports.LANG_LOCALE_MAPPING), function (langCode) {
    return !exports.LANG_LOCALE_MAPPING[langCode].isTest;
    // @ts-ignore
}).map(function (code) { return exports.DYNAMIC_TRANSLATIONS_LANGUAGE_MAPPINGS[code] || code; });
var isMomentSupported = function (languageCode) {
    return !!languageCode && !!exports.LANG_LOCALE_MAPPING[languageCode];
};
exports.isMomentSupported = isMomentSupported;
var getMomentCode = function (languageCode) {
    // @ts-ignore
    return exports.LANG_LOCALE_MAPPING[languageCode].momentLocale;
};
exports.getMomentCode = getMomentCode;
